import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const HmsregWorkspace = lazy(() => import('./screens/HmsregWorkspace'));
const WalletRoute = lazy(() => import('./screens/WalletRoute'));

export function HmsregApp() {
  return (
    <Suspense fallback={<div role="status">Loading…</div>}><Routes>
      <Route path="/" element={<HmsregWorkspace />} />
      <Route path="/wallet" element={<WalletRoute />} />
    </Routes></Suspense>
  );
}
